import React, { useEffect } from "react";
import PageHeader from "../../components/Header/PageHeader";
import { PageWrapper } from "../../components/Page";
import { Button } from "../../components/Button";
import {
  ArrowBack,
  ArrowForward,
  LibraryAddCheckOutlined,
  CheckBoxOutlined,
} from "@material-ui/icons";
import { Checkbox } from "../../components/Input";
import { useDispatch } from "react-redux";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useHistory } from "react-router";
import content from "../../content";
import { Stepper } from "../../components/Header";
import { Visualizer } from "../Visualizer";
import { Link } from "react-router-dom";
import { DrawerMenu } from "../../components/Menu";

function OrderConfirmation({}: IOrderConfirmation) {
  const dispatch = useDispatch();
  const history = useHistory<{ order: any }>();

  const id = history?.location?.state?.order?.id;
  const order = history?.location?.state?.order;


  return (
    <>
      <PageHeader
        header={content.getValue("header_confirmation").replace("%i%", id)}
      >
        <Stepper />
      </PageHeader>
      <PageWrapper
        padding={"0px"}
        menu={
          <>
            <DrawerMenu
              Icon={
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="21" cy="21" r="21" fill="#080808" />
                  <path
                    d="M30.6875 21C30.6875 26.3503 26.3503 30.6875 21 30.6875C15.6497 30.6875 11.3125 26.3503 11.3125 21C11.3125 15.6497 15.6497 11.3125 21 11.3125C26.3503 11.3125 30.6875 15.6497 30.6875 21ZM19.8795 26.1295L27.067 18.942C27.311 18.6979 27.311 18.3021 27.067 18.0581L26.1831 17.1742C25.939 16.9301 25.5433 16.9301 25.2992 17.1742L19.4375 23.0359L16.7008 20.2992C16.4568 20.0551 16.061 20.0551 15.8169 20.2992L14.933 21.183C14.689 21.4271 14.689 21.8229 14.933 22.0669L18.9955 26.1294C19.2396 26.3735 19.6354 26.3735 19.8795 26.1295Z"
                    fill="white"
                  />
                </svg>
              }
              title={content.getValue("drawer_confirmation_title")}
              text={content.getValue("drawer_confirmation_text")}
            />
            <div
              style={{
                height: "100%",
                boxSizing: "border-box",
                padding: "24px",
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <div style={{ width: "100%" }}>
                <Link to={"/"}>
                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    startIcon={
                      <svg
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                          fill="#838282"
                        />
                      </svg>
                    }
                    label={content.getValue("button_back_to_creator")}
                  />
                </Link>
              </div>
            </div>
          </>
        }
      >
        <Visualizer preview={true} order={order} />
      </PageWrapper>
    </>
  );
}

export interface IOrderConfirmation {}

export default OrderConfirmation;
